import axios from 'axios';
import cfac22 from '../cfac22';

export async function getPartnerUserForms(partnerId = cfac22('partnerId')) {
  const endpoint = `${cfac22('API_HOST_V2')}/partnerUserForms?partnerId=${encodeURIComponent(partnerId)}`;
  const { data } = await axios.get(endpoint, {
    withCredentials: true,
    headers: { 'Full-Url': window.location.href },
  });
  if (!data?.success && !data?.result) throw new Error(data?.error || 'Formulário indisponível.');
  return data.result;
}
